module.exports = __webpack_public_path__ + "static/img/s1.325180a2.jpg";